<div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="d-flex justify-content-end m-1" *ngIf="!impactFields.length && !isProcessing">
    <div class="d-flex gap-3">
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="openAddFieldPopup()" (keydown.enter)="openAddFieldPopup()">
            <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
            <span class="reload_text text-white">Add Impact Assessment(s) </span>
        </div>
    </div>
</div>

<div class="d-flex justify-content-end m-1 freeze-buttons"
    *ngIf="impactFields.length && !message.isLevel1EvaluationFrozen && !isProcessing">
    <div class="d-flex gap-3">
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="update()"
            (keydown.enter)="update()">
            <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
            <span class="reload_text text-white">Update</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="openAddFieldPopup()" (keydown.enter)="openAddFieldPopup()">
            <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
            <span class="reload_text text-white">Add Impact Assessment(s)</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openDeletePopup()"
            (keydown.enter)="openDeletePopup()">
            <i class="fa fa-trash" style="font-size: 18px;color: white;"></i>
            <span class="reload_text text-white">Delete Field(s)</span>
        </div>
    </div>
</div>

<div *ngIf="impactFields.length && !isProcessing">
    <ng-container *ngFor="let field of impactFields">
        <div class="row" style="margin-top: 1px;">
            <div class="col-md-3">
                <label id="category-name" for="email">{{ field.fieldName }}</label>
            </div>

            <div class="col-md-3">
                <div>
                    <label id="analytical-lab-investigation" for="email">
                        Response
                    </label>
                    <span class="mandatory-symbol">*</span>
                </div>
                <ng-container [ngSwitch]="field.fieldTypeCode">
                    <!-- Text Field -->
                    <input *ngSwitchCase="'Text Field'" class="form-control" [(ngModel)]="field.response"
                        [disabled]="message.isLevel1EvaluationFrozen" (ngModelChange)="changeDetected()">

                    <!-- Date Field -->
                    <input *ngSwitchCase="'Date Field'" type="text" class="form-control data-picker-continer"
                        bsDatepicker (bsValueChange)="changeDetected()" [bsConfig]="commonDateConfig"
                        [dateCustomClasses]="dateCustomClasses" [(ngModel)]="field.response"
                        [disabled]="message.isLevel1EvaluationFrozen">

                    <!-- Large Text -->
                    <textarea *ngSwitchCase="'Large Text'" class="form-control" rows="4" [(ngModel)]="field.response"
                        (ngModelChange)="changeDetected()" [disabled]="message.isLevel1EvaluationFrozen"></textarea>

                    <!-- Drop Down -->
                    <mat-select *ngSwitchCase="'Drop Down'" [(ngModel)]="field.response" placeholder="Select"
                        (closed)="dropDownSearchText=''" (selectionChange)="changeDetected()"
                        (click)="focusSearch('search')" [disabled]="message.isLevel1EvaluationFrozen"
                        (keydown.enter)="focusSearch('search')">
                        <input matInput type="search" [(ngModel)]="dropDownSearchText" class="dropdownsearchstyle"
                            placeholder="Search">
                        <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                        <mat-option *ngFor="let item of field.fieldValues | assessmentSearch : dropDownSearchText"
                            [value]="item">{{ item }}</mat-option>
                    </mat-select>

                    <!-- Multiselect Drop Down -->
                    <mat-select *ngSwitchCase="'Multiselect Drop Down'" multiple #multiselect [(ngModel)]="field.dd"
                        placeholder="Select" (selectionChange)="changeDetected()" (closed)="dropDownSearchText=''"
                        (click)="focusSearch('multi-search')" [disabled]="message.isLevel1EvaluationFrozen"
                        (keydown.enter)="focusSearch('multi-search')">
                        <input matInput type="multi-search" [(ngModel)]="dropDownSearchText" placeholder="Search"
                            class="dropdownsearchstyle">
                        <div class="select-all">
                            <mat-checkbox [(ngModel)]="multiSelection"
                                (change)="toggleAllSelection('multiselect')">Select
                                All</mat-checkbox>
                        </div>
                        <mat-option *ngFor="let q of field.fieldValues | assessmentSearch : dropDownSearchText"
                            [value]="q">
                            {{ q }}
                        </mat-option>
                    </mat-select>

                    <!-- Vertical Radio Button -->
                    <mat-radio-group *ngSwitchCase="'Vertical Radio Button'" [(ngModel)]="field.response"
                        class="d-flex flex-column" matTooltipPosition="below" (change)="changeDetected()">
                        <mat-radio-button *ngFor="let val of field.fieldValues" [value]="val"
                            [disabled]="message.isLevel1EvaluationFrozen">
                            {{ val }}
                        </mat-radio-button>
                    </mat-radio-group>

                    <!-- Horizontal Radio Button -->
                    <mat-radio-group *ngSwitchCase="'Horizontal Radio Button'" [(ngModel)]="field.response"
                        class="d-inline-flex" matTooltipPosition="below" (change)="changeDetected()">
                        <mat-radio-button *ngFor="let val of field.fieldValues" [value]="val"
                            [disabled]="message.isLevel1EvaluationFrozen">
                            {{ val }}
                        </mat-radio-button>
                    </mat-radio-group>

                    <!-- Vertical Checkbox Button -->
                    <ng-container *ngSwitchCase="'Vertical Checkbox Button'">
                        <section *ngFor="let val of field.fieldValues" class="d-flex flex-column">
                            <mat-checkbox (change)="onCheckboxChange($event, val, field); changeDetected();"
                                [checked]="field.dd.indexOf(val) != -1" [disabled]="message.isLevel1EvaluationFrozen">
                                {{ val }}
                            </mat-checkbox>
                        </section>
                    </ng-container>

                    <!-- Horizontal Checkbox Button -->
                    <ng-container *ngSwitchCase="'Horizontal Checkbox Button'" style="align-items: center;">
                        <section *ngFor="let val of field.fieldValues" class="d-inline-flex">
                            <mat-checkbox [checked]="field.dd.indexOf(val) != -1"
                                (change)="onCheckboxChange($event, val, field); changeDetected();"
                                [disabled]="message.isLevel1EvaluationFrozen">
                                {{ val }}
                            </mat-checkbox>
                        </section>
                    </ng-container>
                </ng-container>
            </div>

            <div class="col-md-3">
                <div>
                    <label id="justification" for="email">
                        Justification
                    </label>
                    <span class="mandatory-symbol">*</span>
                </div>
                <textarea class="form-control" rows="4" [(ngModel)]="field.justification"
                    (ngModelChange)="changeDetected()" [disabled]="message.isLevel1EvaluationFrozen"></textarea>
            </div>

            <div class="col-md-3">
                <div>
                    <label id="remarks" for="email">
                        Remarks
                    </label>
                </div>
                <textarea class="form-control" rows="4" [(ngModel)]="field.remarks" (ngModelChange)="changeDetected()"
                    [disabled]="message.isLevel1EvaluationFrozen"></textarea>
            </div>
        </div>
    </ng-container>
</div>

<ng-template #addPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="closeAddFieldPopup()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{popupTitle}} </label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px;">

        <ng-container *ngIf="templateList.length"></ng-container>
        <div class="col-md-12" style="margin: 3px;">
            <mat-radio-group class="tp-radio-group" [(ngModel)]="selectedOption">
                <mat-radio-button class="tp-radio-button" color="primary" *ngFor="let list of criteriaList"
                    [value]="list" (change)="onPrimaryOptionChange($event)">
                    {{list}}
                </mat-radio-button>
            </mat-radio-group>
        </div> <br>

        <div *ngIf="selectedOption == 'Choose from Template' && templateList.length">
            <div class="col-md-5">
                <label id="template-name" for="email">Select Template</label>&nbsp;
                <mat-select matInput multiple placeholder="Select" #templateRef [(ngModel)]="template"
                    (closed)="templateSearchText=''" (click)="focusSearch('focus-template')"
                    (keydown.enter)="focusSearch('focus-template')">
                    <input type="search" id="focus-template" class="dropdownsearchstyle"
                        [(ngModel)]="templateSearchText" matInput placeholder="search">
                    <div class="select-all">
                        <mat-checkbox [(ngModel)]="templateSelection" (change)="toggleAllSelection('template')">
                            Select All</mat-checkbox>
                    </div>
                    <mat-option *ngFor="let item of templateDropDown | multiAssessmentSearchPipe : templateSearchText"
                        [value]="item.valueExp" (onSelectionChange)="onTemplateSelect($event,item)">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
        </div>

        <div *ngIf="selectedOption == 'Choose from Template' && !templateList.length" style="text-align: center;">
            <b>Please add Impact Assessment data in Settings</b>
        </div>

        <div *ngIf="selectedOption == 'Add Manually'">
            <div class="row">
                <div
                    [ngClass]="field.fieldTypeCode && field.fieldTypeCode != 'Large Text' && field.fieldTypeCode != 'Text Field' ? 'col-md-4' : 'col-md-3'">
                    <div>
                        <!-- Field Name  -->
                        <label id="field-name" for="email">Field Name</label>
                        <span class="mandatory-symbol">*</span>
                    </div>
                    <input class="input-filed-continers" type="text" [(ngModel)]="field.fieldName"
                        (ngModelChange)="onNgModelChange($event,'field-name')">
                </div>

                <div
                    [ngClass]="field.fieldTypeCode && field.fieldTypeCode != 'Large Text' && field.fieldTypeCode != 'Text Field' ? 'col-md-4' : 'col-md-3'">
                    <div>
                        <!-- Sub Department -->
                        <label id="field-type" for="email">Field Type Code</label>
                        <span class="mandatory-symbol">*</span>
                    </div>
                    <mat-select matInput placeholder="Select" [(ngModel)]="field.fieldTypeCode"
                        (closed)="fieldTypeSearchText=''" (click)="focusSearch('type-focus')"
                        (keydown.search)="focusSearch('type-focus')">
                        <input type="search" id="type-focus" class="dropdownsearchstyle"
                            [(ngModel)]="fieldTypeSearchText" matInput placeholder="Search">
                        <mat-option class="unselectStyle" [value]="null"
                            (onSelectionChange)="onFieldTypeSelect($event,null);">Un-select</mat-option>
                        <mat-option *ngFor="let item of fieldTypeDropDown | assessmentSearch :fieldTypeSearchText"
                            (onSelectionChange)="onFieldTypeSelect($event,item)" [value]="item.valueExp">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                </div>

                <div class="col-md-4"
                    *ngIf="field.fieldTypeCode && field.fieldTypeCode != 'Large Text' && field.fieldTypeCode != 'Text Field'">
                    <div>
                        <!-- Field Name  -->
                        <label id="field-values" for="email">Field Values</label>
                        <span class="mandatory-symbol">*</span>
                    </div>
                    <input class="input-filed-continers" type="text" [(ngModel)]="field.fieldValues"
                        (ngModelChange)="onNgModelChange($event,'field-values')">
                </div>


                <div class="col-md-6">
                    <div>
                        <!-- Instructions -->
                        <label for="email">Instructions</label>
                    </div>
                    <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                        [(ngModel)]="field.instructions"></textarea>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions
            *ngIf="selectedOption && template">
            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="addFromTemplate()" (keydown.enter)="addFromTemplate()"
                *ngIf="selectedOption == 'Choose from Template'">
                <img src=" ../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
                <span class="reload_text text-white">Add Fields</span>
            </div>
            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="addManually(field)" (keydown.enter)="addManually(field)"
                *ngIf="selectedOption == 'Add Manually'">
                <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
                <span class="reload_text text-white">Add Field</span>
            </div>
            <button mat-stroked-button class="cancelButton" (click)="closeAddFieldPopup()">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>
    </div>
</ng-template>

<ng-template #deletePopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="closeDeletePopup()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> Delete </label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px;">

        <div class="col-md-12" style="margin: 3px;">
            <mat-radio-group class="tp-radio-group" [(ngModel)]="selectedOption">
                <mat-radio-button class="tp-radio-button" color="primary" *ngFor="let list of criteriaList"
                    [value]="list" (change)="onDeletionOptionChange($event)">
                    {{list}}
                </mat-radio-button>
            </mat-radio-group>
        </div> <br>

        <div class="row" *ngIf="selectedOption">
            <div class="col-md-6">
                <div>
                    <label id="delete-reason" for="email">Reason for Delete</label>
                    <span class="mandatory-symbol">*</span>
                </div>
                <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                    [(ngModel)]="deleteReason"></textarea>
            </div>
        </div>

        <div *ngIf="selectedOption=='Delete Manually'">
            <div class="table-container" style="align-items : center;">
                <table style="max-height: 45vh;">
                    <thead>
                        <th style="min-width: 60px; text-align: center;">
                            <div style="display: flex;">
                                <div>
                                    <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
                                </div>
                                <div style="margin-left: 5px;">
                                    <input type="checkbox" style="zoom: 1.2;" [(ngModel)]="parentCheckBox"
                                        (change)="onParentCheckBoxChanged($event)">
                                </div>
                            </div>
                        </th>
                        <th class="control-text" style="width: 240px; text-align: center;">
                            <span> Field </span>
                            <span class="grid-header-container"> </span>
                        </th>
                        <th class="control-text" style="width: 240px; text-align: left;">
                            <span> Field Type </span>
                            <span class="grid-header-container"> </span>
                        </th>
                    </thead>
                    <tbody>
                        <tr *ngFor=" let field of impactFields; let idx=index;">
                            <td style="min-width: 80px; text-align: center;">
                                <div style="display: flex;">
                                    <div [ngClass]="field.childCheckBox ?'static_icon':'hover-menu-icons'">
                                        <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </div>
                                    <div style="margin-left: 5px;">
                                        <input id="selectedUserCheckBox`" type="checkbox" style="zoom: 1.2;"
                                            [checked]="field.childCheckBox"
                                            (change)="onChildCheckBoxChanged($event, field, idx)">
                                    </div>
                                </div>
                            </td>
                            <td class="control-text" style="width: 240px; text-align: center;">
                                <span> {{ field.fieldName }} </span>
                            </td>
                            <td class="control-text" style="text-align: left;">
                                <span> {{ field.fieldTypeCode }} </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="deleteMethod()"
                (keydown.enter)="deleteMethod()"
                *ngIf="deleteReason && (selectedOption === 'Delete All' || (selectedOption === 'Delete Manually' && tempArray.length))">
                <i class="fa fa-trash" style="font-size: 18px;color: white;"></i>
                <span class="reload_text text-white">{{selectedOption=='Delete All' ? 'Delete All' : 'Delete'}}</span>
            </div>
            <button mat-stroked-button class="cancelButton" (click)="closeDeletePopup()">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>
    </div>
</ng-template>

<ng-template #resultPopup>
    <div class="ng-template-container">
        <div class="page-loading-shade" *ngIf="isProcessing">
            <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
        </div>
        <button class="close close-button" (click)="cancelResultPopup()" mat-button><i
                class="fa popupClose">&#xf00d;</i></button>
        <div mat-dialog-title>
            <label for="title" class="popupTitle"> Field Result(s) </label>
            <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
        </div>
        <div class="table-container" style="margin: 10px;">
            <table style="max-height: 65vh;">
                <thead>
                    <th class="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Field</span>
                        </div>
                    </th>

                    <th class="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '350px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Result</span>
                        </div>
                    </th>

                    <th id="menu" class="sticky-col first-col"></th>
                </thead>
                <tbody>
                    <tr class="data-row-container" *ngFor="let r of responses; let idx = index;">
                        <td class="row-data">
                            <!--Is commented for later debugging {{isAdding}} -->
                            {{ isAdding ? r.field.fieldName : r.field.fieldName }}
                        </td>
                        <td class="row-data"
                            [ngStyle]=" r.response.resultType == 'S' ? {'color': 'green'} :{'color':'red'}">
                            {{ r.response.result }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
        <button mat-stroked-button class="cancelButton" (click)="cancelResultPopup()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>